export default "__VITE_ASSET__CE2BZ4QP__"